import React, { useEffect } from 'react';
import Modal from 'react-modal';
import { useParams } from 'react-router-dom';
import { observer } from 'mobx-react';
import { v4 as uuidv4 } from 'uuid';
import { useStores } from '../../hooks/use-stores';
import { Box, Button } from '@material-ui/core';
import { CloseBtn, Title } from '../UI/Modal';
import { fields } from './fields';
import Loader from '../../components/Loader';

const RentOrderModal = observer(({ open, onClose }) => {
    const { categoryId } = useParams();
    const { OrderStore: store, ProductStore, CartStore } = useStores();

    //// Effects
    useEffect(() => {
        return () => {
            store.resetRentFields();
            store.resetValues();
        };
    }, [store]);

    // Get autofill datas
    useEffect(() => {
        if (open) {
            store.getRentFields(categoryId);
        }
    }, [categoryId, open, store]);

    // Autofills
    useEffect(() => {
        store.setValues({
            companyName: store.userData?.company?.title,
            contactPerson: store.userData?.fio,
            phone: store.userData?.phone,
            modelName: ProductStore.product?.name,
        });

        if (categoryId === '27') {
            store.setValues({
                rentHours: 5,
            });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [store, store.userData, categoryId]);

    // Handlers
    const handleSubmit = e => {
        e.preventDefault();

        CartStore.add({
            id: uuidv4(),
            product: store.product,
            values: store.values,
            count: 1,
        });

        onClose();
    };

    // Renders
    const renderFields = () => {
        if (!store.rentFields.length) {
            return <Loader />;
        }

        return store.rentFields.map(({ name, type, values }, index) => {
            if (fields[name]) {
                switch (type) {
                    case 'input':
                    case 'textarea':
                        return (
                            <Box mb={3} key={index}>
                                {fields[name](name, store.values[name], store.handleInputChange)}
                            </Box>
                        );
                    case 'radio':
                        return (
                            <Box mb={1} key={index}>
                                {fields[name](name, store.values[name], store.handleInputChange)}
                            </Box>
                        );
                    case 'autocomplete':
                        return (
                            <Box mb={3} key={index}>
                                {fields[name](name, store.values[name], values, store.handleChange)}
                            </Box>
                        );
                    case 'rangePicker':
                        return (
                            <Box mb={3} key={index}>
                                {fields[name](name, store.values[name], store.handleChange)}
                            </Box>
                        );
                    case 'datePicker':
                        return (
                            <Box mb={3} key={index}>
                                {fields[name](name, store.values[name], store.handleChange)}
                            </Box>
                        );
                    case 'incDecNumber':
                        return (
                            <Box mb={3} key={index}>
                                {fields[name](name, store.values[name], store.handleChange)}
                            </Box>
                        );
                    case 'checkbox':
                        return <Box key={index}>{fields[name](name, store.values[name], store.handleCheckboxChange)}</Box>;
                    case 'points':
                        return (
                            <Box mb={3} key={index}>
                                {fields[name](name, store.values[name], store.handleInputChange, store.userData?.points)}
                            </Box>
                        );
                    default:
                        return null;
                }
            }

            return null;
        });
    };

    return (
        <Modal
            isOpen={open}
            onClose={onClose}
            onRequestClose={onClose}
            className="Modal order-modal"
            shouldCloseOnOverlayClick={false}
            shouldCloseOnEsc={false}
            ariaHideApp={false}
        >
            <CloseBtn onClose={onClose} />
            <Box mb={3}>
                <Title align="center">Арендовать {ProductStore.product.name}</Title>
            </Box>

            <form onSubmit={handleSubmit}>
                {renderFields()}

                <Button variant="outlined" color="primary" type="submit" disabled={store.fieldsLoading || store.loading}>
                    Добавить в корзину
                </Button>
            </form>
        </Modal>
    );
});

export default RentOrderModal;
